import styled from 'styled-components';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { setIsMenuOpen } from '@/state/menuSlice';
import {THEME_MODES} from "@repo/ui/themeSettings";
import { revealAnimationContainer } from "@repo/ui";

const StyledWrapper = styled(revealAnimationContainer('div', 'menu-item-reveal-up'))`
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: ${({ theme }) => (theme.mode === THEME_MODES.DARK ? theme.colors.white : theme.colors.twilightBlue)};
`;

const StyledHeader = styled.p`
	font-size: 40px;
	letter-spacing: -1.6px;

	&.active {
		font-style: italic;
		font-weight: 300;
	}
	&.disabled {
		color: #E2E2E2!important;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		font-size: 50px;
		letter-spacing: -2px;
	}
`;

const StyledLine = styled.div`
	border-top: 1px solid ${({ theme }) => (theme.mode === THEME_MODES.DARK ? theme.colors.white : theme.colors.twilightBlue)};
	margin: 0 15px;
	flex-grow: 0;
`;

const StyledSubHeader = styled.p`
	font-size: 12px;
	text-transform: uppercase;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		font-size: 14px;
	}
`;

const MobileMenuItem = ({ item, isDisabled }) => {
	const router = useRouter();
	const dispatch = useDispatch();
	const pathname = usePathname().split('/')[1];
	const text = item?.link?.menuContext?.previewText || ''
	const secondText = item?.link?.menuContext?.secondText || '';
	const slug = item?.link?.slug || '';

	const isActive = useMemo(() => {
		return pathname === slug;
	}, [pathname, slug]);

	const handleClick = (e) => {
		e.preventDefault();
		// dispatch(setIsMenuOpen(false));
		router.push(`/${slug}`);
	};

	return (
		<StyledWrapper>
			<StyledHeader className={`${isActive && 'active'} ${isDisabled ? 'disabled' : ''}`} onClick={isDisabled ? null : handleClick}>
				{text}
			</StyledHeader>
			{isActive && <StyledLine className="menu-mobile-line" />}
			<StyledSubHeader>{secondText}</StyledSubHeader>
		</StyledWrapper>
	);
};

export default MobileMenuItem;
